export function isBlueBearAccessHostname(hostname) {
  const normalized = String(hostname || '').trim().toLowerCase().split(':')[0];
  return [
    'access.bluebear.ai',
    'www.access.bluebear.ai',
    'access-dev.bluebear.ai',
    'access-dev.136-117-236-230.nip.io',
  ].includes(normalized);
}
